import { useUserLanguage } from '@/customHooks';
import { BudgetStatusOption } from '@/graphql/generated';
import { LanguageType } from '@/custom-types';

type BudgetStatusPillProps = {
  option: BudgetStatusOption
}

const pillBase = 'inline-flex items-center justify-center rounded-full px-3 py-1 text-[0.7rem] font-bold'

const optionMapping = (option: BudgetStatusOption, language: LanguageType) => {
  const pending = { className: 'text-[#FF971D] bg-[#FF971D21]' }
  const rejected = { className: 'text-[#808080] bg-[#ECECEC]' }
  const accepted = { className: 'text-[#4a9462] bg-[#d2f3dc]' }

  const mapping: Record<
    LanguageType,
    Record<BudgetStatusOption, { text: string; className: string }>
  > = {
    en: {
      [BudgetStatusOption.Pending]: { text: 'Pending', ...pending },
      [BudgetStatusOption.Rejected]: { text: 'Rejected', ...rejected },
      [BudgetStatusOption.Accepted]: { text: 'Accepted', ...accepted },
    },
    es: {
      [BudgetStatusOption.Pending]: { text: 'Pendiente', ...pending },
      [BudgetStatusOption.Rejected]: { text: 'Rechazado', ...rejected },
      [BudgetStatusOption.Accepted]: { text: 'Aceptado', ...accepted },
    },
  }

  return mapping[language][option]
}

export const BudgetStatusPill = ({ option }: BudgetStatusPillProps) => {
  const userLanguage = useUserLanguage()

  const optionMapped = optionMapping(option, userLanguage)
  return (
    <div className={`${pillBase} ${optionMapped.className}`}>
      {optionMapped.text}
    </div>
  );
}
